import { Config } from '../../../config'
import styled from 'styled-components'

export type PlaceholderProps = {
  text?: boolean
  image?: boolean
  width?: string
  halfOnDesktop?: boolean
  absolute?: boolean
  thin?: boolean
}

// TODO: animation
export const Placeholder = styled.div<PlaceholderProps>`
  width: ${(props) => (props.image ? '100%' : props.width)};
  height: ${(props) => (props.image ? '0' : props.thin ? '0.6rem' : '1rem')};

  padding-bottom: ${(props) => (props.image ? '100%' : '0')};

  ${(props) =>
    props.absolute &&
    `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-bottom: 0;
  `}

  ${(props) =>
    props.halfOnDesktop &&
    `
    @media (min-width: ${props.theme.breakpoints.lg.min}) {
      width: calc(50% - 0.8rem);
      margin-bottom: 1.6rem;
    }
  `}

  background: ${({ theme }) => theme.palette.disabled};
`
